import { Box, Paper, Typography, IconButton, Button } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { CloseIcon } from "../../../minimals/theme/overrides/CustomIcons";
import SalesRepForm from "./SalesRepForm";
import { InternalUser } from "../../types/app";

type Props = {
  onClose: () => void;
  salesReps: (InternalUser | null)[];
  setSalesReps: Dispatch<SetStateAction<(InternalUser | null)[]>>;
  marketingReps: (InternalUser | null)[];
  setMarketingReps: Dispatch<SetStateAction<(InternalUser | null)[]>>;
  onSubmit: (reps: (InternalUser | null)[]) => void;
};
const AllMatchingSalesRepsForm = ({
  onClose,
  salesReps,
  setSalesReps,
  marketingReps,
  setMarketingReps,
  onSubmit
}: Props) => {
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          bgcolor: "rgba(15,23,42,0.45)",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          pt: 5,
          zIndex: 1300
        }}
      >
        <Paper sx={{ width: "min(1100px, 95vw)", borderRadius: 2, overflow: "hidden", boxShadow: 6 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Which set of Sales Reps would you like to write to the Order?
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Typography
            variant="body2"
            sx={{ color: "#b71c1c", px: 2, py: 1, borderBottom: "1px solid", borderColor: "divider" }}
          >
            (Edit the dropdowns if you want something else entirely)
          </Typography>

          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, p: 2 }}>
            <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
              <Box
                sx={{
                  bgcolor: "#F3F5FF",
                  p: 2,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  minHeight: "100px"
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  These Sales Reps are tied to the Orders' previous existing{" "}
                  <span
                    style={{ color: "rgb(255, 174, 0)", fontSize: "1.2em", textShadow: "0 0 1px rgb(255, 174, 0)" }}
                  >
                    ★
                  </span>{" "}
                  Marketing Source:
                </Typography>
              </Box>
              <Box sx={{ p: 2 }}>
                <SalesRepForm salesReps={salesReps} setSalesReps={setSalesReps} />
                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    // sx={customButtonStyles}
                    onClick={() => onSubmit(salesReps)}
                  >
                    Use These
                  </Button>
                </Box>
              </Box>
            </Paper>

            <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
              <Box
                sx={{
                  bgcolor: "#F2FCF7",
                  p: 2,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  minHeight: "100px"
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  The contact edit you've submitted has these Sales Reps in the Phonebook:
                </Typography>
              </Box>
              <Box sx={{ p: 2 }}>
                <SalesRepForm salesReps={marketingReps} setSalesReps={setMarketingReps} />
                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                  <Button variant="contained" color="primary" onClick={() => onSubmit(marketingReps)}>
                    Use These
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Box>
        </Paper>
      </Box>
    </>
  );
};
export default AllMatchingSalesRepsForm;
